import React, { Fragment } from 'react';
export function Footer() {
  const links = [{
    label: 'Términos y Condiciones',
    href: '/terminos'
  }, {
    label: 'Privacidad',
    href: '/privacidad'
  }, {
    label: 'Cookies',
    href: '/cookies'
  }, {
    label: 'Configurar cookies',
    href: '/cookies#configurar'
  }, {
    label: 'Reembolsos y devoluciones',
    href: '/reembolsos'
  }];
  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    window.open(href, '_blank', 'noopener,noreferrer');
  };
  return <footer className="bg-[#1a1a1a] text-gray-400 py-8" data-id="element-25">
      <div className="max-w-7xl mx-auto px-6" data-id="element-26">
        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 mb-6" data-id="element-27">
          {links.map((link, index) => <Fragment key={index} data-id="element-28">
              <a href={link.href} onClick={e => handleLinkClick(e, link.href)} className="text-sm hover:text-[#d4a5a5] transition-colors duration-200 cursor-pointer" data-id="element-29">
                {link.label}
              </a>
              {index < links.length - 1 && <span className="hidden md:inline text-gray-600" data-id="element-30">•</span>}
            </Fragment>)}
        </div>
        <p className="text-center text-sm text-gray-500" data-id="element-31">
          &copy; {new Date().getFullYear()} El Divorcio Emocional. Todos los
          derechos reservados.
        </p>
      </div>
    </footer>;
}